import axios from 'axios';

export default {
  namespaced: true,

  state: {
    notifications: [],
  },

  getters: {
    notifications(state) {
      return state.notifications;
    },
    notificationsByUserType(state, getters, rootState, rootGetters) {
      // the regex match the string after the last backslash. In this case the UserType
      return state.notifications
        .filter(
          (notification) => notification.notifiable_type.match(/[^/\\]+$/)[0].toLowerCase() === rootGetters['auth/user'].user_type
            || notification.notifiable_type.match(/[^/\\]+$/)[0] === 'User',
        )
        .sort((firstItem, secondItem) => secondItem.updated_at - firstItem.updated_at);
    },
    hasNotifications(state) {
      return !!state.notifications.length;
    },
    toReadNotificationsCounter(state, getters) {
      return getters.notificationsByUserType
        .filter((notification) => !notification.read_at).length;
    },
  },

  mutations: {

    SET_NOTIFICATIONS(state, notifications) {
      state.notifications = notifications;
    },

    UPDATE_NOTIFICATION(state, notification) {
      const index = state.notifications.findIndex((item) => item.id === notification.id);
      state.notifications.splice(index, 1, notification);
    },

    ADD_AS_FIRST(state, notification) {
      if (!state.notifications.some((item) => item.id === notification.id)) {
        state.notifications.unshift({
          ...notification,
        });
      }
    },

    PUSH(state, notification) {
      state.notifications.push({
        ...notification,
      });
    },

    DELETE(state, notificationToRemove) {
      state.notifications = state.notifications
        .filter((notification) => notification.id !== notificationToRemove.id);
    },

    DELETE_NOTIFICATION(state, id) {
      state.notifications = state.notifications
        .filter((notification) => notification.id !== id);
    },
  },

  actions: {
    add({ commit }, notificationToAdd) {
      commit('PUSH', notificationToAdd);
    },
    addFromPusher({ commit }, pusherNotification) {
      console.log(pusherNotification.id);
      const notificationToAdd = {
        id: pusherNotification.id,
        notifiable_type: pusherNotification.notifiableType,
        type: pusherNotification.type,
        notifiable_id: pusherNotification.notifiableId,
        data: pusherNotification.data,
        read_at: null,
        replied_at: null,
      };
      commit('ADD_AS_FIRST', notificationToAdd);
    },
    remove({ commit }, notificationToRemove) {
      commit('DELETE', notificationToRemove);
    },

    async delete({ commit }, id) {
      await axios.delete(`/api/notifications/${id}`);
      commit('DELETE_NOTIFICATION', id);
    },

    async markAsRead({ commit }, notification) {
      const { data } = await axios.put(`/api/notifications/${notification.id}`) || [];
      commit('UPDATE_NOTIFICATION', data);
    },

    async markAsReplied({ commit }, notification) {
      const { data } = await axios.patch(`/api/notifications/replies/${notification.id}`);
      commit('UPDATE_NOTIFICATION', data);
    },

    async getNotifications({ commit, rootGetters }) {
      const { data: userNotifications } = await axios.get(`/api/user/${rootGetters['auth/user'].id}/notifications`) || [];
      const { data: studentNotifications } = rootGetters['auth/isStudent'] ? await axios.get(`/api/student/${rootGetters['auth/student'].id}/notifications`) : { data: [] };
      const { data: teacherNotifications } = rootGetters['auth/isTeacher'] ? await axios.get(`/api/teacher/${rootGetters['auth/teacher'].id}/notifications`) : { data: [] };

      commit('SET_NOTIFICATIONS', userNotifications.concat(studentNotifications, teacherNotifications));
    },
  },
};
